import React, { useState, useRef ,Fragment} from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import "../Analytics.css";
import ReactApexChart from "react-apexcharts";
import { useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Chart from "react-apexcharts";
import SideNavigationBar from "../../reusables/SideNavigationBar/SideNavigationBar";
import DiagnosticInterview_1 from "../BatchWiseAnalytics/DiagnosticInterview_1";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AccountCircle } from "@mui/icons-material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useReactToPrint } from 'react-to-print';
import ScrollButton from "../../reusables/ScrollButton";
const Line = () => {
  return (
    <svg width="235" height="7" viewBox="0 0 235 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M235 3.73438L229.996 0.854691L230.004 6.62819L235 3.73438ZM0.000706449 4.56641L2.02657 4.56354L2.02516 3.56354L-0.000706449 3.56641L0.000706449 4.56641ZM6.07829 4.55782L10.13 4.55209L10.1286 3.5521L6.07688 3.55782L6.07829 4.55782ZM14.1817 4.54637L18.2335 4.54064L18.2321 3.54065L14.1803 3.54637L14.1817 4.54637ZM22.2852 4.53492L26.3369 4.5292L26.3355 3.5292L22.2838 3.53492L22.2852 4.53492ZM30.3886 4.52347L34.4404 4.51775L34.4389 3.51775L30.3872 3.52347L30.3886 4.52347ZM38.4921 4.51202L42.5438 4.5063L42.5424 3.5063L38.4907 3.51202L38.4921 4.51202ZM46.5955 4.50057L50.6473 4.49485L50.6458 3.49485L46.5941 3.50057L46.5955 4.50057ZM54.699 4.48912L58.7507 4.4834L58.7493 3.4834L54.6976 3.48912L54.699 4.48912ZM62.8024 4.47767L66.8541 4.47195L66.8527 3.47195L62.801 3.47767L62.8024 4.47767ZM70.9059 4.46622L74.9576 4.4605L74.9562 3.4605L70.9045 3.46622L70.9059 4.46622ZM79.0093 4.45477L83.061 4.44905L83.0596 3.44905L79.0079 3.45478L79.0093 4.45477ZM87.1128 4.44333L91.1645 4.4376L91.1631 3.4376L87.1113 3.44333L87.1128 4.44333ZM95.2162 4.43188L99.2679 4.42615L99.2665 3.42615L95.2148 3.43188L95.2162 4.43188ZM103.32 4.42043L107.371 4.4147L107.37 3.4147L103.318 3.42043L103.32 4.42043ZM111.423 4.40898L115.475 4.40325L115.473 3.40325L111.422 3.40898L111.423 4.40898ZM119.527 4.39753L123.578 4.3918L123.577 3.3918L119.525 3.39753L119.527 4.39753ZM127.63 4.38608L131.682 4.38035L131.68 3.38035L127.629 3.38608L127.63 4.38608ZM135.733 4.37463L139.785 4.3689L139.784 3.36891L135.732 3.37463L135.733 4.37463ZM143.837 4.36318L147.889 4.35746L147.887 3.35746L143.835 3.36318L143.837 4.36318ZM151.94 4.35173L155.992 4.34601L155.991 3.34601L151.939 3.35173L151.94 4.35173ZM160.044 4.34028L164.096 4.33456L164.094 3.33456L160.042 3.34028L160.044 4.34028ZM168.147 4.32883L172.199 4.32311L172.198 3.32311L168.146 3.32883L168.147 4.32883ZM176.251 4.31738L180.302 4.31166L180.301 3.31166L176.249 3.31738L176.251 4.31738ZM184.354 4.30593L188.406 4.30021L188.404 3.30021L184.353 3.30593L184.354 4.30593ZM192.458 4.29448L196.509 4.28876L196.508 3.28876L192.456 3.29448L192.458 4.29448ZM200.561 4.28303L204.613 4.27731L204.611 3.27731L200.56 3.28304L200.561 4.28303ZM208.664 4.27158L212.716 4.26586L212.715 3.26586L208.663 3.27159L208.664 4.27158ZM216.768 4.26014L220.82 4.25441L220.818 3.25441L216.766 3.26014L216.768 4.26014ZM224.871 4.24869L228.923 4.24296L228.922 3.24296L224.87 3.24869L224.871 4.24869Z"
        fill="#1C8EA8"
      />
    </svg>
  );
};

const StudentWiseAnalytics = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const componentRef = useRef();
  const scrollToElementRef = useRef(null);

  const queryParams = new URLSearchParams(location.search);
  console.log("ANimesh", location);
  //FIXME: USE THIS DATA TO FETCH EXACT DATA FOR THE USER
  const user_id = queryParams.get("user_id");
  const [promptnessQuotient, setPropmptnessQuotient] = useState(0);
  const [activityTime, setActivityTime] = useState(null);
  const [mostActiveDay, setMostActiveDay] = useState([]);
  const ActivityImage = [
    { image: " https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime1.png", time: "12am-6am" },
    { image: " https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime4.png", time: "6am-12pm" },
    { image: " https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime3.png", time: "12pm-6pm" },
    { image: " https://du03hetco8xdw.cloudfront.net/analytics/StudentAciveTime5.png", time: "6pm-12am" },
  ];

  const program_id = location.state?.userGroupId;
  const college_id = location.state?.college_id;
  const college_name = location.state?.college_name;
  const program_name = location.state?.program_name;
  const process_id = location.state?.process_id;

  const progress_tracker = location.state?.progress_tracker;
  const activated_students = location.state?.activated_students;
  const non_activated_students = location.state?.non_activated_students;
  const [studentReportDownload, setStudentReportDownload] = useState(false)
  const [topRoles, setTop_roles] = useState([]);

  const [chartData, setChartData] = useState({
    chart: {
      borderRadius: "20px",
      type: "bar",
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true, // Display bars horizontally
        columnWidth: "50%",
      },
    },
    grid: { show: false },
    colors: ["#6CE5E8", "#E88F09"],
    barWidth: 10,
    legend: {
      show: true,
      position: "top",
      showForSingleSeries: true,
      fontSize: "12px",
      barWidth: 10,
      // borderRadius:"20px"
      // customLegendItems: ["Role Preference"],
    },
    xaxis: {
      axisBorder: { show: false },
      categories: ["Role-1", "Role-2"],
    },
    yaxis: {
      axisBorder: { show: false },
    },
  });

  const [roleSeries, setRoleSeries] = useState([
    {
      name: "Your Score",
      data: [0, 0],
    },
    {
      name: "CC Community Wise Percentile",
      data: [0, 0],
    },
  ]);

  const [seq, setSeq] = useState();

  const [itAllAboutNumbers, setitAllAboutNumbers] = useState({
    series: [
      {
        data: [],
      },
    ],
    options: {
      chart: {
        borderRadius: "20px",
        type: "bar",
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          horizontal: true,
          //   height:100
        },
      },
      xaxis: {
        axisBorder: { show: false },
        categories: ["Logical test", "Verbal test", "Aptitude Test"],
        max: 100,
      },

      grid: { show: false },
      colors: ["#AFE5F1"],
      barWidth: 10,
      legend: {
        show: false,
        position: "top",
        showForSingleSeries: true,
        fontSize: "14px",
        barWidth: 10,
        // borderRadius:"20px"
        // customLegendItems: ["Role Preference"],
      },
    },
  });

  const [countElement, setCountElement] = useState(-1);

  const [chartOptions, setChartOptions] = useState({
    plotOptions: {
      bar: {
        borderRadius: 10,
        horizontal: true,
      },
    },
    stroke: {
      colors: ["#F44336"],
    },
    dataLabels: {
      enabled: false,
    },
    grid: { show: false },
    colors: "#41B8D5",
    chart: { width: "200px",
    toolbar: {
      show: false
    } },
    xaxis: {
      axisBorder: { show: false },
    },
    yaxis: {
      max: 100,
      min: 0,

      labels: {
        show: false,
        style: {
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 400,
        },
      },
    },
  });
  const [series, setSeries] = useState([
    {
      data: [],
    },
  ]);

  const handleData = (data) => {
    setPropmptnessQuotient(data.user_performance[0].total_p);

    if (data.day_student_map.length > 0) {
      let mostActiveDays = [
        { day: "Monday", value: data.day_student_map[0].mon },
        { day: "Tuesday", value: data.day_student_map[0].tue },
        { day: "Wednesday", value: data.day_student_map[0].wed },
        { day: "Thursday", value: data.day_student_map[0].thu },
        { day: "Friday", value: data.day_student_map[0].fri },
        { day: "Saturday", value: data.day_student_map[0].sat },
        { day: "Sunday", value: data.day_student_map[0].sun },
      ];

      mostActiveDays = mostActiveDays.sort((a, b) => b.value - a.value);
      mostActiveDays = mostActiveDays.filter((item) => item.value !== 0);
      if (mostActiveDays.length > 3) {
        setMostActiveDay(mostActiveDays.slice(0, 3));
      } else {
        setMostActiveDay(mostActiveDays);
      }
    }

    let userTest = data.overall_user_test_type.length > 0 ? data.overall_user_test_type[0] : [];

    if (Object.keys(userTest)) {
      let keys = Object.keys(userTest);
      keys = keys.filter((item) => item !== "user_id" && item !== "total" && item !== "1");
      let userData = keys.map((item) => {
        if (userTest[item] === null) {
          return null;
        } else {
          return userTest[item].toFixed(2);
        }
      });

      userData = userData.filter((item) => item !== null);
      console.log("valuesss", userData);

      setitAllAboutNumbers((prev) => {
        return {
          ...prev,
          series: [
            {
              data: userData,
            },
          ],
        };
      });
    }

    let temp_data = data.overall_role_wize_test.length > 0 ? Object.keys(data.overall_role_wize_test[0]) : [];
    let category = temp_data.map((item) => {
      if (data.overall_role_wize_test[0][item] === null) {
        return null;
      } else {
        return item;
      }
    });
    // category = category.filter((item) => item !== null);
    category = category.filter((item) => item !== "user_id" && item !== "total" && item !== null);
    console.log("temp_data", temp_data);
    let batchData = category.map((item) => {
      return data.batch_role_wize_test[0][item] ? data.batch_role_wize_test[0][item].toFixed(2) : data.batch_role_wize_test[0][item];
    });
    let overall_data = category.map((item) => {
      return data.overall_role_wize_test[0][item] ? data.overall_role_wize_test[0][item].toFixed(2) : data.overall_role_wize_test[0][item];
    });
    let top_roles = category.slice().sort((a, b) => data.batch_role_wize_test[0][b] - data.overall_role_wize_test[0][a]);
    setTop_roles(top_roles.slice(0, 3));

    if (data.time_student_map.length > 0) {
      let temp_time = Object.keys(data.time_student_map[0]);
      temp_time = temp_time.filter((item) => item !== "user_id");
      let student_time_data = temp_time[0];
      temp_time.map((item) => {
        if (data.time_student_map[0][item] > data.time_student_map[0][student_time_data]) {
          student_time_data = item;
        }
      });

      setActivityTime(student_time_data);
    }
    setChartData((prev) => {
      return {
        ...prev,
        xaxis: {
          axisBorder: { show: false },
          categories: category,
        },
      };
    });

    setRoleSeries([
      {
        name: "Your Score",
        data: batchData,
      },
      {
        name: "CC Community Wise Percentile",
        data: overall_data,
      },
    ]);

    // test_data = [data.overall_user_test_type[0]["2"], data.overall_user_test_type[0]["3"], data.overall_user_test_type[0]["4"]];

    // setChartData((prev) => {
    //   return {
    //     ...prev,
    //     series: [
    //       {
    //         data: [200, 100],
    //       },
    //     ],
    //   };
    // });
  };

  useEffect(() => {
    const getData = async () => {
      if (Cookies.get("token") === null || Cookies.get("token") === undefined) {
        navigate("/");
      }
      const config = {
        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
      };
      const userData = await axios.get(`${process.env.REACT_APP_API_URL}/analytics/user/stats?user_id=${user_id}`, config);
      const SEQDate = await axios.get(`${process.env.REACT_APP_API_URL}/analysis/engagementQuotient?user_id=${user_id}`, config);
      
      console.log("UserData", SEQDate.data);
      setSeq(SEQDate.data.getEngagementQuotient[0]);
      setSeries([
        {
          data: [SEQDate.data.getEngagementQuotient[0].seq * 100],
        },
      ]);
      handleData(userData.data);

      if(studentReportDownload === true){
        handlePrint()
      }
 
    };
    

    getData();
  }, [studentReportDownload]);

  useEffect(() => {
    if(!progress_tracker) {
      console.log("progress tracker", progress_tracker);
      scrollToElementRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [seq])

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      console.log("elemntreached Bottom", countElement);
      // Check if the user has scrolled to the bottom of the page
      if (windowHeight + scrollTop + 10 > documentHeight) {
        // Increment the count by one when the user reaches the bottom
        setCountElement((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [countElement]);

  const handleBatchDataAnalyticsClick = () => {
    navigate("/BatchWiseAnalytics", { state: { college_id: college_id, college_name: college_name, program_id: program_id, program_name: program_name , non_activated_students:non_activated_students, activated_students:activated_students} });
  };

  const goBack = () => {
    console.log("Back Button is Clicked Now");
    navigate(-1);
  };

  const handlePrintStudent = () => {
    setStudentReportDownload(true)
    // handlePrint()
  }

  const handlePrint =
    useReactToPrint({
      pageStyle: `@media print {
        .page-break {
          page-break-after: always !important;
        }
        .page-break:first-of-type {
          page-break-before: always !important;
        }
        
      }`,
      content: () => componentRef.current,
      onAfterPrint: () => {
        setStudentReportDownload(false)
      },
    });

    

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <SideNavigationBar />
      <div className="analyticsMainDiv" style={{ alignSelf: "center", width: "80%", marginTop: "2rem" }}>
        <ArrowBackIcon className="Arrow-back-btn" style={{ height: "30px", width: "30px", marginRight: "0.5rem", marginBottom: ".5rem" }} onClick={() => goBack()} />

        <Box display="flex" justifyContent="space-between">
          <Typography variant="h2">Student Analytics Report</Typography>
          <button
            onClick={() => {
              handleBatchDataAnalyticsClick();
            }}
            className="batch-button"
            style={{ width: "auto", paddingLeft: ".5rem", paddingRight: ".5rem" }}
          >
            View Batch Data Analytics
          </button>
        </Box>
        {/* <Box display="flex" float="right" alignItems="center" marginBottom="1rem">
          <Box display="flex" marginRight="1rem" border="1px solid #41B8D5" borderRadius="5px" paddingRight=".5rem" paddingLeft=".5rem">
            <GetAppIcon style={{ color: "#41B8D5" }} />
            <Typography style={{ color: "#41B8D5", margin: "auto" }}>Data CSV</Typography>
          </Box>

        </Box> */}
        <Box paddingBlock={".5rem"} display="flex" sx={{ borderBlock: "1px solid #E8E8E8", display: "flex", gap: "1.5rem", alignItems: "center", justifyContent:"space-between", marginTop:".5rem" }}>
            <Box display="flex">
              {location.state.image ? <img src={location.state.image} style={{ width: "50px", borderRadius: "50%", border: "2px sold #41B8D5" }} /> : <AccountCircle sx={{ fontSize: "28px" }} />}
              <Typography sx={{ fontSize: "17px", alignItems:'center', marginTop:".2rem", marginLeft:".5rem" }}>{location.state.student_name}</Typography>
            </Box>
            <Box display="flex" border="1px solid #41B8D5" borderRadius="5px" paddingRight=".5rem" paddingLeft=".5rem" style={{ cursor: "pointer", float:"right" }} onClick={handlePrintStudent}>
              <GetAppIcon style={{ color: "#41B8D5" }} />
              <Typography style={{ color: "#41B8D5", margin: "auto" }} >Student Report</Typography>
            </Box>
          </Box>
        <Fragment>
        <Box ref={componentRef} >
          <Box className="page-break">
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", marginTop: "1.5rem", marginBottom: "1.5rem" }}>
            <Box sx={{ height: "2px", width: "100%", background: "#E88F09" }}></Box>
            <Typography variant="h1" sx={{ color: "#E88F09", textAlign: "center", fontWeight: "600", width: "800px", letterSpacing: "2.5px" }}>
              Progress Tracker
            </Typography>
            <Box sx={{ height: "2px", width: "100%", background: "#E88F09" }}></Box>
          </Box>
          <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem" }}>
            <Typography variant="h2" style={{ fontWeight: "bold", textAlign: "center" }}>
              {location.state.student_name} | {location.state.student_roll_no}
            </Typography>
            <Typography variant="h6" sx={{ color: "#FF3131", textAlign: "center", marginTop: "1rem" }}>
              DISCLAIMER
            </Typography>
            <Typography class="body1font2" style={{ textAlign: "center" }}>
              All information in these reports are provided “as is”, with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind. All quantifications or comments in all reports have no bearing on actual performance of any individual or group. These scores may vary from 1 session to another. The company will not be liable to you or anyone else for any decision made or action taken in reliance on the information given by these reports or for any consequential, special or similar damages, even if advised of the possibility of such damages.
            </Typography>
          </Box>
            <div style={{ display: "flex", flexDirection: "column", marginTop:"1.5rem", width:"100%" ,height: "auto" }}>
                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                  <div style={{ display: "flex" }}>
                    <div style={{ display: "flex", flexDirection: "column", width: "40%", marginLeft:".3rem" }}>
                      <div>
                        <Card class="analytics-card-content" style={{ padding: "1.5rem" }}>
                          <CardContent>
                            <Typography variant={studentReportDownload ? "h2" : "h1"} sx={{ color: "#1C8EA8", textAlign: "center", marginBottom: "1.5rem" }}>
                              Promptness Quotient
                            </Typography>
                            <Box width="100%" alignItems="center">
                            <Box sx={{ marginBottom: "1.5rem", width:"100%" }}>
                              <Box sx={{ display: "flex", justifyContent: "space-between", boxShadow: "0px 0px 35px 0px rgba(0, 0, 0, 0.07)", padding: "10px", borderRadius: "36px" }}>
                                {[0, 1, 2, 3, 4, 5].map((item) => {
                                  if (item < Math.round((promptnessQuotient * 10) / 2)) {
                                    return (
                                      <Box sx={{}}>
                                        <Box sx={{ width: studentReportDownload ? "28px" : "45px", height: studentReportDownload ? "30px" : "45px", background: "#6CE5E8", borderRadius: "50%" }}></Box>
                                      </Box>
                                    );
                                  } else if (item === Math.round((promptnessQuotient * 10) / 2)) {
                                    return (
                                      <Box sx={{ scale: "1.2" }}>
                                        <Box sx={{ width: studentReportDownload ? "28px" : "45px", height: studentReportDownload ? "30px" : "45px", background: "#6CE5E8", borderRadius: "50%" }}></Box>
                                      </Box>
                                    );
                                  } else {
                                    return (
                                      <Box sx={{}}>
                                        <Box sx={{ width: studentReportDownload ? "28px" : "45px", height: studentReportDownload ? "30px" : "45px", background: "#E6E6E6", borderRadius: "50%" }}></Box>
                                      </Box>
                                    );
                                  }
                                })}
                              </Box>
                              <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "0.5rem", alignItems: "center", gap: "1rem" }}>
                                <Typography variant="h5">Sluggish</Typography>
                                <Line />
                                <Typography variant="h5">Swift</Typography>
                              </Box>
                            </Box>

                            {/* <Chart options={dayWisePromptenessOptions} series={dayWiseData} type="bar" width={"100%"} height={300} borderRadius={10} /> */}

                            <Box sx={{ marginBottom: "1.5rem" }}>
                              <Typography variant="h5" sx={{ color: "#8B8B8B", textAlign: "center", marginBottom: "1rem" }}>
                                Most Active Days
                              </Typography>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                {mostActiveDay.length > 0 ? (
                                  mostActiveDay.map((item, index) => (
                                    <Box sx={{ borderLeft: index === 0 ? "" : "1px solid #8B8B8B", width: "100%" }}>
                                      <Typography variant={studentReportDownload ? "h4" : "h3"} sx={{ textAlign: index === 0 ? "left" : "center", color: "#1C8EA8" }}>
                                        {item.day}
                                      </Typography>
                                    </Box>
                                  ))
                                ) : (
                                  <Typography variant="h3" sx={{ color: "#525252" }}>
                                    No Data Available
                                  </Typography>
                                )}
                              </Box>
                            </Box>

                            <Box sx={{}}>
                              <Typography class="body1font2" style={{ color: "#8B8B8B" }}>
                                Description
                              </Typography>
                              <Typography style={{fontSize:"10px"}}>The above-mentioned representation (promptness meter) is displayed in terms of the following student facets: Time taken to activate their accounts, feedback provided to respective mentors, time taken to book their interviews, and time taken to join scheduled sessions.</Typography>
                            </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      </div>
                      <div style={{ width: "100%" }}>
                        <Card class="analytics-card-content" style={{ padding: "1.5rem" }}>
                          <CardContent>
                            <Typography variant={studentReportDownload ? "h2" : "h1"} sx={{ color: "#1C8EA8", textAlign: "center", marginBottom: "1.5rem" }}>
                              Student Engagement Quotient (SEQ)
                            </Typography>

                            {series[0].data.length > 0 && <Chart options={chartOptions} series={series} type="bar" width={studentReportDownload ? "50%" : "90%"} height={100} />}
                            <Box sx={{ display: "flex", justifyContent: "space-between", paddingLeft: "1rem", marginBottom: "1.5rem" }}>
                              <Typography sx={{ fontSize: "12px" }}>Casual</Typography>

                              <Typography sx={{ fontSize: "12px" }}>Committed</Typography>
                            </Box>
                            <Box sx={{}}>
                              <Typography class="body1font2" style={{ color: "#8B8B8B" }}>
                                Description
                              </Typography>
                              <Typography  style={{fontSize:"10px"}}>According to the following facets: Tests taken, feedback viewed, feedback given, podcasts listened to, sessions watched, session recordings viewed - the student's engagement score is calculated and set on a scale of committed to casual. Committed being most engaged with the app content and sessions. Casual being least engaged with app content and sessions</Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </div>
                    </div>

                    {/* Role  */}
                    <div style={{ height: "100%", width: "45%" }}>
                      <Card class="analytics-card-content" style={{ padding: "1.5rem" }}>
                        <CardContent>
                          <Typography variant={studentReportDownload ? "h2" : "h1"} sx={{ color: "#1C8EA8", textAlign: "center", marginBottom: "1.5rem" }}>
                            Role Preparedness
                          </Typography>

                          {roleSeries[1].data.length > 0 ? (
                            <>
                              <ReactApexChart options={chartData} series={roleSeries} type="bar" height={roleSeries[1].data.length * 180} width={studentReportDownload ? "50%" :"80%"}/> <Typography sx={{ fontSize: "14px", color: "#8B8B8B", textAlign: "center" }}>Other Interested Roles</Typography>
                              <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
                                {topRoles.map((item) => (
                                  <Typography sx={{ fontSize: "16px", color: "#1C8EA8" }}>{item}</Typography>
                                ))}
                              </Box>
                              <Box sx={{ marginTop: "1.5rem" }}>
                                <Typography class="body1font2" style={{ color: "#8B8B8B" }}>
                                  Description
                                </Typography>
                                <Typography  style={{fontSize:"10px"}}>Roles displayed above are the top 3 roles in which the student performed best. Role preparedness percentiles are calculated using the scores of role preparedness tests on the CareerCarve app. For example, if a student is in the 80th percentile, it means they did better than 80% of the batch. Percentiles were calculated using normalised scores of all such tests. "Other interested roles" are arrived at by candidate's activity on the app. For example- if a candidate consumed substantial pre-recorded content for a specific role, it will start showing here.</Typography>
                              </Box>
                            </>
                          ) : (
                            <Typography sx={{ fontSize: "18px", color: "#828282" }}>No Data Available</Typography>
                          )}
                        </CardContent>
                      </Card>
                    </div>
                    <div style={{ width: "15%", marginRight:".3rem" }}>
                  <Card class="analytics-card-content" style={{ padding: "1.5rem", marginRight:"0px" }}>
                    <CardContent>
                      <Typography variant={studentReportDownload ? "h2" : "h1"} sx={{ color: "#1C8EA8", textAlign: "center", marginBottom: "1.5rem" }}>
                        Active Time
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", gap: "20px" }}>
                        {ActivityImage.map((item) => (
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img src={item.image} style={{ width: "100%", height: "100%", borderRadius: "50%", filter: activityTime === item.time ? "" : "saturate(0%)", opacity: activityTime === item.time ? 1 : 0.5 }} />
                            <Typography sx={{ fontSize: "14px", color: activityTime === item.time ? "#41B8D5" : "#8A8A8A", textAlign: "center", marginTop: "10px" }}>{item.time}</Typography>
                          </Box>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </div>
                  </div>

                  {/* All about Number  */}
                  <Card class="analytics-card-content" style={{ padding: "1.5rem" , marginRight:".3rem", marginLeft:".3rem"}}>
                    <CardContent>
                      <Typography variant={studentReportDownload ? "h2" : "h1"} sx={{ color: "#1C8EA8", textAlign: "center", marginBottom: "1.5rem" }}>
                        It's all about numbers
                      </Typography>
                      {itAllAboutNumbers.series[0].data.length > 0 ? (
                        <>
                          <Box sx={{ display: "flex", gap: "2rem", alignItems: "center", justifyContent: "center" }}>
                            <ReactApexChart options={itAllAboutNumbers.options} series={itAllAboutNumbers.series} type="bar" height={itAllAboutNumbers.series[0].data.length * 70} width={550} />
                            <Box sx={{ display: "flex", flexDirection: "column", paddingBlock: "50px", gap: "40px" }}>
                              {itAllAboutNumbers.series[0].data.map((item) => (
                                <Typography variant="h5" sx={{ color: "#1C8EA8" }}>
                                  {item}/100
                                </Typography>
                              ))}
                            </Box>
                          </Box>
                          <Box sx={{}}>
                            <Typography class="body1font2" style={{ color: "#8B8B8B" }}>
                              Description
                            </Typography>
                            <Typography  style={{fontSize:"10px"}}>Percentiles mentioned above are calculated using average scores of category-wise aptitude tests (if any) of the student on CareerCarve app. Overall percentile notifies where does the student stand after combining all normalized aptitude test scores compared to their peers.</Typography>
                          </Box>
                        </>
                      ) : (
                        <Typography sx={{ fontSize: "18px", color: "#828282" }}>No Data Available</Typography>
                      )}
                    </CardContent>
                  </Card>
                </div>

                
              
            </div>
            </Box>
          {console.log("student_analysis_content", location.state.allProcess)}
          {(studentReportDownload || !progress_tracker) ? <>
            {location.state.allProcess.length > 0 && location.state.allProcess.map((item, index) => 
            <div ref = {item.process_id === process_id ? scrollToElementRef : null} className="page-break">
             <DiagnosticInterview_1 studentReportDownload={studentReportDownload} user_id={user_id} process_id={item.process_id} sku_name={item?.sku_name} user_group_id={location.state.userGroupId} />
             </div>)}
          </> : <>
          {location.state.allProcess.length > 0 && location.state.allProcess.map((item, index) => countElement >= index && <DiagnosticInterview_1 user_id={user_id} process_id={item.process_id} sku_name={item?.sku_name} user_group_id={location.state.userGroupId} />)}
          </>}
          
        
        </Box>
        </Fragment>
        <ScrollButton />
      </div>
    </div >
  );
};

export default StudentWiseAnalytics;
